define('RecipesAndEvents.Ingredient.View', [
    'Backbone.CompositeView',
    'SC.Configuration',
    'Store.Item.Price.Helper',
    'ingredient_details.tpl',
    'Profile.Model',
    'Backbone',
    'ProductViews.Price.View',
    'Item.Model'
], function RecipesAndEventsIngredientView(
    BackboneCompositeView,
    Configuration,
    StoreItemPriceHelper,
    ingredientDetailsTpl,
    ProfileModel,
    Backbone,
    ProductViewsPriceView,
    ItemModel
) {
    'use strict';

    return Backbone.View.extend({
        template: ingredientDetailsTpl,
        initialize: function initialize() {
            Backbone.View.prototype.initialize.apply(this, arguments);
            BackboneCompositeView.add(this);
        },

        childViews: {
            'Price.View': function priceViewFn() {
                return new ProductViewsPriceView({
                    model: new ItemModel(this.model.toJSON())
                });
            }
        },
        getContext: function getContext() {
            var images = this.model.get('itemimages_detail') && this.model.get('itemimages_detail').urls &&
                this.model.get('itemimages_detail').urls.length && this.model.get('itemimages_detail').urls[0];
            return {
                displayname: this.model.get('displayname'),
                thumbnail: images && images.url ? images.url : Configuration.get('recipesAndEvents.notAvailableImage'),
                product_id: this.model.get('internalid'),
                url_component: this.model.get('urlcomponent')
            };
        }
    });
});
